const CostEffectivePlan = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M17.5595 35.3966C15.9801 35.3966 14.5362 34.539 13.7689 33.2304L12.9565 31.8316C12.7759 31.651 12.6857 31.5156 12.6857 31.5156L7 43.3391L11.8284 42.2111L14.3105 46.0018L19.5 35.3516L17.5595 35.3513L17.5595 35.3966Z"
        fill="#B8CBFC"
      />
      <path
        d="M35.6534 32.9574C34.8861 34.3111 33.4421 35.1236 31.8628 35.1236L29.3359 35.3038L34.4803 45.773L36.9624 41.9823L41.7908 43.1103L36.3305 31.7383L35.6534 32.9574Z"
        fill="#B8CBFC"
      />
      <path
        d="M25.6875 23.2981L25.8229 23.253C26.3646 23.1627 26.8156 22.937 27.1766 22.6662C27.6731 22.2148 27.8988 21.5833 27.8988 20.7257C27.8988 20.1841 26.7707 19.823 25.8229 19.6428L25.6875 19.5977L25.6875 23.2981Z"
        fill="#2D65F2"
        fillOpacity="0.5"
      />
      <path
        d="M22.2068 14.3211C21.8005 14.8176 21.62 15.3589 21.7103 16.081C21.8457 16.9837 22.8835 17.4347 23.7862 17.6153L23.9216 17.6605V13.3281L23.7862 13.3733C23.3348 13.5538 22.6581 13.8246 22.2068 14.3211Z"
        fill="#2D65F2"
        fillOpacity="0.5"
      />
      <path
        d="M40.7574 17.4329L39.0877 14.4998V11.2508C39.0877 10.5286 38.6815 9.85192 38.05 9.49085L35.2523 7.86629L33.5826 4.97831C33.2216 4.3464 32.5449 3.94052 31.8228 3.94052H28.4835L25.5956 2.27081C24.9637 1.90973 24.1967 1.90973 23.5648 2.27081L20.6762 3.94017H17.382C16.6599 3.94017 15.9832 4.34639 15.6222 4.97795L13.9521 7.776L11.019 9.44571C10.3872 9.80679 9.98128 10.4835 9.98128 11.2056V14.5901L8.35675 17.3878C8.17621 17.7037 8.08594 18.0648 8.08594 18.4256C8.08594 18.7867 8.17621 19.1478 8.35675 19.4634L9.98128 22.2611V25.6455C9.98128 26.3677 10.3875 27.0444 11.019 27.4054L13.9521 29.0752L15.5767 31.918C15.9377 32.5499 16.6144 32.9558 17.3365 32.9558L20.6762 32.9568L23.5641 34.6265C23.88 34.8071 24.2411 34.8974 24.6019 34.8974C24.9629 34.8974 25.324 34.8071 25.6396 34.6265L28.5276 32.9568H31.8668C32.589 32.9568 33.2656 32.5506 33.6267 31.919L35.2964 29.0311L38.094 27.4065C38.7259 27.0454 39.1318 26.3687 39.1318 25.6466V22.3975L40.8015 19.4644C41.1633 18.8318 41.1633 18.0649 40.7574 17.4329ZM25.8206 17.8843C27.2646 18.0648 29.7016 18.6967 29.7016 20.7271C29.7016 22.0808 29.2502 23.2093 28.393 23.9762C27.5355 24.7435 26.5429 24.9688 25.8658 25.0591H25.7755V26.9996H24.0156V24.924H23.9254C20.0896 24.0665 20.0896 20.7271 20.0896 20.682V20.4112H21.8044V20.682C21.8044 20.7723 21.8496 22.3969 23.8352 23.0738L24.0157 23.119V19.4636H23.9254C22.6169 19.238 20.3605 18.5161 20.0897 16.3499C19.9091 15.1316 20.2251 14.0484 20.9924 13.1911C21.6694 12.4238 22.7522 11.8374 23.9254 11.6117H24.0157V9.85174H25.7756V11.5666H25.8659C28.6184 12.018 29.6113 14.7706 29.7468 16.1694L29.7919 16.4403L28.0771 16.6208L28.0319 16.35C28.0319 16.2597 27.7611 13.9581 25.9561 13.3717L25.7755 13.3266V17.9294L25.8206 17.8843Z"
        fill="#2D65F2"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export default CostEffectivePlan;
